import {
  Button,
  Form,
  Input,
  message
} from "antd";

import {
  LockOutlined
} from "@ant-design/icons";

import AccountShell
  from "./accountShell";

import axiosInstance
  from "../../utils/axios";

const getUser = () => {
  try {
    return JSON.parse(
      localStorage.getItem("user")
    );
  } catch (e) {
    return null;
  }
};

export default function AccountPassword() {
  const user = getUser();

  const submit = async values => {
    if (
      values.password !==
      values.passwordConfirm
    ) {
      message.error(
        "Mật khẩu xác nhận không khớp."
      );

      return;
    }

    try {
      const res =
        await axiosInstance.post(
          "/user/changePassword",
          {
            email: user?.email,
            passwordCurrent:
              values.passwordCurrent,
            password:
              values.password
          }
        );

      if (
        Number(
          res?.data?.status
        ) === 1
      ) {
        message.success(
          res?.data?.message ||
          "Đổi mật khẩu thành công."
        );
      } else {
        message.error(
          res?.data?.message ||
          "Không thể đổi mật khẩu."
        );
      }
    } catch (error) {
      message.error(
        "Không thể đổi mật khẩu."
      );
    }
  };

  return (
    <AccountShell
      title="Đổi mật khẩu"
      description="Bảo vệ tài khoản của bạn"
    >
      <div
        className="
          max-w-xl
          mx-auto
        "
      >
        <div
          className="
            w-14 h-14
            rounded-2xl
            bg-blue-50
            text-blue-600
            flex
            items-center
            justify-center
            text-2xl
            mb-5
          "
        >
          <LockOutlined />
        </div>

        <Form
          layout="vertical"
          onFinish={submit}
        >
          <Form.Item
            name="passwordCurrent"
            label="Mật khẩu hiện tại"
            rules={[
              {
                required: true,
                message:
                  "Vui lòng nhập mật khẩu hiện tại"
              }
            ]}
          >
            <Input.Password
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="Mật khẩu mới"
            rules={[
              {
                required: true,
                message:
                  "Vui lòng nhập mật khẩu mới"
              }
            ]}
          >
            <Input.Password
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="passwordConfirm"
            label="Xác nhận mật khẩu mới"
            rules={[
              {
                required: true,
                message:
                  "Vui lòng xác nhận mật khẩu"
              }
            ]}
          >
            <Input.Password
              size="large"
            />
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            size="large"
            block
          >
            Đổi mật khẩu
          </Button>
        </Form>
      </div>
    </AccountShell>
  );
}
